// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GQXbASBOsZI4oKGOmRKy{flex-direction:column;flex:1;display:flex}.TmQV1d4eOEiZp3ZxLtBj{align-items:center;gap:8px;padding:10px 0;display:flex}.MoADzEAOsW8TleIBMnlY{margin:16px 0}.In7KdwEYJpkExDCTHplm{--dropdown-checked-margin-left:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `GQXbASBOsZI4oKGOmRKy`,
	"emailCell": `TmQV1d4eOEiZp3ZxLtBj`,
	"sectionTitle": `MoADzEAOsW8TleIBMnlY`,
	"dropdownList": `In7KdwEYJpkExDCTHplm`
};
export default ___CSS_LOADER_EXPORT___;
